import {IconType} from "react-icons";

import {Icon} from "@/components/icon/Icon.tsx";

import styles from "./ChartTypeLabel.module.scss";

interface ChartTypeLabelProps {
  icon: IconType;
  label: string;
}

export const ChartTypeLabel = ({icon, label}: ChartTypeLabelProps) => (
  <span className={styles.label}>
    <Icon icon={icon} removeDivDimensions />
    {label}
  </span>
);
